export {SeasonTableModule} from './season-table.module';
export {SeasonTableComponent} from './season-table.component';

export * from './season-table-data.model';
